<div class="lds-dual-ring" [ngClass]="classeTamanhoDualRing">
  <img
    src="assets/images/logos/cs.png"
    class="logo"
    [ngClass]="classeTamanhoLogo"
  />
</div>
